import {environment as defaultEnvironment} from './environment.default';

export const environment = {
  ...defaultEnvironment,
  env: 'prod',
  production: true,

  // billing-api
  billingApiUrl: 'https://billing.prd.maplabs.run/api',

  // main-api
  apiUrl: 'https://main.prd.maplabs.run/api',  

  // core-api
  coreApiUrl: 'https://core.prd.maplabs.run',

};
